export const StatusEnum = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
});

export const CognitoStatusEnum = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
});

export const relationStatuses = Object.freeze({
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED',
  PENDING: 'PENDING',
});
